import { observer } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
import { useNavigate, useParams, Navigate } from "react-router-dom";
import { Spin } from "antd";
import { globalModel } from "../../global/GlobalModel";
import { ShellTopBar } from "../shell/ShellTopBar";
import { LobbyModel } from "./LobbyModel";
import type { InfluencerCard } from "./LobbyType";
import { sitePageBackgroundStyle } from "../../SiteConfig";
import { cornerLabel } from "./relatedSpacesFollowsLogic";
import "./LobbyStyle.css";

const ID8 = /^\d{8}$/;

/** 陈列场馆（从首页带 spaceId 进入）；「与我相关的空间」已全局弹框化，不再有此整页路由 */
const LobbyPage = observer(() => {
  const { spaceId: arenaFromRoute } = useParams<{ spaceId: string }>();
  const navigate = useNavigate();
  const arenaId =
    arenaFromRoute && ID8.test(arenaFromRoute) ? arenaFromRoute : "";

  const model = useMemo(
    () =>
      arenaId ? new LobbyModel("arena", arenaId) : null,
    [arenaId]
  );

  useEffect(() => {
    if (model) {
      void model.load();
    }
  }, [model]);

  if (!arenaId) {
    return <Navigate to="/" replace />;
  }
  if (!globalModel.isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  const onCardClick = (targetSpaceId: string) => {
    navigate(`/space/${targetSpaceId}/home`);
  };

  return (
    <div className="lobby-root" style={sitePageBackgroundStyle("lobby")}>
      <ShellTopBar />
      <div className="lobby-body">
        <Spin spinning={!model?.loaded}>
          {model?.loadError && (
            <p className="lobby-error">{model.loadError}</p>
          )}
          {!model?.loadError ? (
            <ul className="lobby-grid">
              {(model?.cards ?? []).map((c: InfluencerCard) => {
                const cr = cornerLabel(c.membershipTag);
                return (
                  <li key={c.id} className="lobby-item">
                    <button
                      type="button"
                      className="lobby-card"
                      onClick={() => onCardClick(c.targetSpaceId)}
                    >
                      {cr ? (
                        <span className="lobby-card-corner" aria-hidden>
                          {cr}
                        </span>
                      ) : null}
                      <div className="lobby-card-media">
                        <img
                          className="lobby-card-img"
                          src={c.coverImageUrl}
                          alt=""
                          loading="lazy"
                        />
                        <div className="lobby-card-foot" aria-hidden>
                          <span className="lobby-card-name">{c.name}</span>
                          <span className="lobby-card-id">
                            {c.targetSpaceId}
                          </span>
                        </div>
                      </div>
                    </button>
                  </li>
                );
              })}
            </ul>
          ) : null}
        </Spin>
      </div>
    </div>
  );
});

export default LobbyPage;
